import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { BillingInfo } from "../types/billingInfo";

export const useUpdateBillingDetails = () => {
  const { authHeader } = useAuth();

  return useMutation((params: BillingInfo) => {
    return axios.patch(
      `${env.verifyServiceUrl}user/billing_information/${params.id}/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
